export default {
  default: {
    fields: {
      default:
        "w-1/2 border border-admin_bordered/30 hover:border-admin_bordered p-5 mx-auto",
      full: "w-full border border-admin_bordered/30 hover:border-admin_bordered p-5 mx-auto",
    },
    groups: {
      default: {
        root: "mb-1",
        panel:
          "h-[50px] w-full flex justify-between items-center cursor-pointer p-4 bg-admin_neutral_1 rounded",
        panel_content:
          "h-[30px] flex flex-row items-center justify-between w-full",
        panel_title: "text-admin_text text-lg mr-5 font-semibold",
        panel_description: "text-sm text-admin_text ml-auto",
        panel_arrow: "text-admin_text ml-2",
        panel_expand_icon: "w-6 h-6 text-admin_text",
        content: "text-admin_text flex flex-row flex-wrap",
      },
    },
  },
}
